import React, {useEffect, useImperativeHandle, useState} from "react";
import useSnackbar from "../../../Snackbar/SnackbarHook";
import {useSearchContext} from "../../../../Contexts/SearchContext";
import {useSearchParams} from "react-router-dom";
import postsService from "../../../../Services/PostsService";
import {formatNumber, formatZip, isValidZip} from "../../../../Utilities/postUtils";
import {Box, TextField, Typography} from "@mui/material";
import Row from "../../../Common/Row";

export const LocationFilterDesktop = React.forwardRef((props, ref) => {
    const snackbar = useSnackbar();
    const searchContext = useSearchContext();

    const [searchParams, setSearchParams] = useSearchParams();

    let latLngParam = searchParams.get("latLng");
    const radiusParam = searchParams.get("radius");

    const [zipCode, setZipCode] = useState("");
    const [radius, setRadius] = useState(radiusParam ?? "");

    useImperativeHandle(ref, () => {
        return {
            onNewLocation: onNewLocation
        }
    });

    useEffect(() => {
        setRadius(radiusParam ?? "")
    }, [radiusParam]);

    // Convert latLng to zipCode
    useEffect(() => {
        if (latLngParam == null) {
            setZipCode("");
            return;
        }

        const latLng = latLngParam?.split(",");
        const lat = latLng[0];
        const lng = latLng[1];

        postsService.latLngToZipCode(lat, lng)
            .then((zip) => {
                // If the conversion was successful
                if (isValidZip(zip)) {
                    setZipCode(zip);
                }
            });
    }, [latLngParam]);


    const onNewLocation = async () => {
        let newRadiusParam = {};
        let newLatLngParam = {};

        if (radius != "") {
            newRadiusParam = {"radius": radius};
        }

        if (zipCode != "") {
            // Convert zip code to latLng
            const latLng = await postsService.zipCodeToLatLng(zipCode);

            // If conversion failed
            if (latLng == null) {
                snackbar.handleOpen("Ugyldigt postnummer", "error");
            } else {
                newLatLngParam = {"latLng": `${latLng[0]},${latLng[1]}`};
            }
        }

        return {
            ...newRadiusParam,
            ...newLatLngParam
        }
    }

    // When the user presses enter in one of the fields
    const onEnter = async (event) => {
        event.target.blur();

        searchContext.refineRadiusAndZipCode(radius, zipCode);
    }

    return <Box>
        <Typography sx={{fontWeight: "bold"}}>Lokation</Typography>
        <Row sx={{
            paddingTop: "10px",
            alignItems: "center"
        }}>
            {/* Radius field */}
            <TextField
                sx={{maxWidth: "100px"}}
                label={"Km"}
                value={radius}
                onChange={(event) => {
                    setRadius(formatNumber({
                        value: event.target.value,
                        maxLength: 4,
                        excludeZero: true,
                        useComma: false
                    }));
                }}
                onKeyUp={(event) => {
                    if (event.key === "Enter") {
                        onEnter(event);
                    }
                }}
            />

            <Typography
                sx={{padding: "0 5px"}}
            >fra</Typography>

            {/* Zip code field */}
            <TextField
                sx={{maxWidth: "100px"}}
                label={"Postnr."}
                value={zipCode}
                onChange={(event) => {
                    setZipCode(formatZip(event.target.value));
                }}
                onKeyUp={(event) => {
                    if (event.key === "Enter") {
                        onEnter(event);
                    }
                }}
            />
        </Row>
    </Box>
});
